import { ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import { useOptionForLocale } from '~/core/hooks/useOptionForLocale';
import { CoreGoal } from '~/core/types';

export const useGoalHighlightClip = (goal: CoreGoal): number | undefined =>
    useOptionForLocale({
        [ShortCodeEnums.Language.English]: goal.highlightClip,
        [ShortCodeEnums.Language.French]: goal.highlightClipFr,
    });

export const useGoalDiscreteClip = (goal: CoreGoal): number | undefined =>
    useOptionForLocale({
        [ShortCodeEnums.Language.English]: goal.discreteClip,
        [ShortCodeEnums.Language.French]: goal.discreteClipFr,
    });

export const useGoalSharingUrl = (goal: CoreGoal): string | undefined =>
    useOptionForLocale({
        [ShortCodeEnums.Language.English]: goal.highlightClipSharingUrl,
        [ShortCodeEnums.Language.French]: goal.highlightClipSharingUrlFr,
    });
